import React from "react";
import { signInOAuth } from "../../services/auth/unifiedAuth";
import { supabaseReady } from "../../lib/supabaseClient";

function isAppleEnvironment(): boolean {
  if (typeof navigator === "undefined") return false;
  return /iphone|ipad|macintosh|mac os x/i.test(navigator.userAgent);
}

type Props = {
  loading: boolean;
  onError?: (msg: string) => void;
  redirectPath?: string; // path interno para o callback (default /oauth/callback)
};

export const SocialAuthButtons: React.FC<Props> = ({ loading, onError, redirectPath = "/oauth/callback" }) => {
  const [loadingProvider, setLoadingProvider] = React.useState<string | null>(null);
  
  async function handle(provider: "google" | "facebook" | "apple") {
    console.log("[SOCIAL_AUTH] provider:", provider);
    console.log("[SOCIAL_AUTH] redirectPath:", redirectPath);
    
    if (!supabaseReady) {
      onError?.("Supabase não configurado. Verifique as variáveis de ambiente.");
      return;
    }
    
    setLoadingProvider(provider);
    
    try {
      await signInOAuth(provider, redirectPath);
      // Após iniciar OAuth, a página será redirecionada
    } catch (e: any) {
      console.error("[SOCIAL_AUTH] Error:", e);
      setLoadingProvider(null);
      const errorMsg = e.message || "Falha ao iniciar login social";
      onError?.(`${provider}: ${errorMsg}`);
    }
  }

  return (
    <div className="space-y-3">
      <button
        type="button"
        disabled={loading || !supabaseReady || loadingProvider !== null}
        onClick={() => handle("google")}
        className="w-full border rounded px-3 py-2 flex items-center justify-center hover:bg-accent disabled:opacity-60 transition-colors"
      >
        {loadingProvider === "google" ? "Redirecionando..." : "Continuar com Google"}
      </button>
      <button
        type="button"
        disabled={loading || !supabaseReady || loadingProvider !== null}
        onClick={() => handle("facebook")}
        className="w-full border rounded px-3 py-2 flex items-center justify-center hover:bg-accent disabled:opacity-60 transition-colors"
      >
        {loadingProvider === "facebook" ? "Redirecionando..." : "Continuar com Facebook"}
      </button>
      {isAppleEnvironment() && (
        <button
          type="button"
          disabled={loading || !supabaseReady || loadingProvider !== null}
          onClick={() => handle("apple")}
          className="w-full border rounded px-3 py-2 flex items-center justify-center hover:bg-accent disabled:opacity-60 transition-colors"
        >
          {loadingProvider === "apple" ? "Redirecionando..." : "Continuar com Apple"}
        </button>
      )}
    </div>
  );
};
